import { TransactionType } from '@unistocks/proxy/axios-client';
import { mapEnumToOptions } from '@unistocks/shared/utils/enum-utils';

export const transactionTypeOptions = mapEnumToOptions(TransactionType, 'TransactionType');
